module.exports = __webpack_public_path__ + "img/Chad.050aeae5.jpg";